import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EnhancedHelpModule } from '@flyfreely-portal-ui/enhanced-help';
import { SharedUiModule } from '@flyfreely-portal-ui/ui';
import { ValidationModule } from '@flyfreely-portal-ui/validation';
import { NgSelectModule } from '@ng-select/ng-select';
import { Angulartics2Module } from 'angulartics2';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ColumnTemplateDirective } from './column-template.directive';
import { FlyFreelyTable } from './dynamic-table/flyfreely-table.component';
import { RowActionsDirective } from './row-actions.directive';
import { RowSelector } from './static-table/row-selector.component';
import { StaticTable } from './static-table/static-table.component';
import { TableAsyncSelection } from './table-async-selection/table-async-selection.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ValidationModule,
        Angulartics2Module,
        SharedUiModule,
        TooltipModule,
        NgSelectModule,
        PopoverModule,
        EnhancedHelpModule,
        PaginationModule,
        BsDatepickerModule
    ],
    providers: [],
    bootstrap: [],
    declarations: [
        FlyFreelyTable,
        StaticTable,
        ColumnTemplateDirective,
        RowActionsDirective,
        RowSelector,
        TableAsyncSelection
    ],
    exports: [
        FlyFreelyTable,
        StaticTable,
        ColumnTemplateDirective,
        RowActionsDirective
    ]
})
export class FlyFreelyTableModule {}
